<template>
  <div v-if="showOffGameBets && showOffGameBets.length > 0" class="nav-jackopt-list-pc">
    <div class="game-title">
      <p>{{ $t('Bao.latest_big_win') }}</p>
    </div>
    <div class="nav-jackpot">
      <i><img src="" alt=""></i>
      <div class="nav-jackpot-text-pc line">
        <span>{{ $t("Bao.bet_game_name") }}</span>
        <span>
          <span>{{ $t("Bao.bet_game_player") }}&nbsp;&nbsp;</span>
          <span>{{ $t("Bao.bet_game_time") }}</span>
          <span>{{ $t("Bao.bet_game_win") }}</span></span>
      </div>
    </div>
    <div
      v-for="(item, key) in visibleItems"
      :key="key"
      class="nav-jackpot"
      :class="{'nav-jackopt-color-pc': shouldApplyClass(key)}"
      @click="handleLaunchGame(item)"
    >
      <i><img :src="getImageSource(item.game.type)" alt=""></i>
      <div class="nav-jackpot-text-pc">
        <div class="nav-jackpot-text-pc">
          <span class="game">{{ item.game_name }}</span>
          <span>
            <span>{{ item.member_nickname }}</span>
            <span>{{ item.created_at | timeFormat }}</span>
            <span>{{ item.bet_result }} {{ $store.getters.brandInfo.currency }}</span></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getShowOffGameBets } from '@/api/game'
import { gameStart } from '@/utils/games'
import { getThemeImagePath } from '@/utils/tool'

export default {
  data() {
    return {
      showOffGameBets: [],
      currentIndex: 0,
      itemsPerPage: 10,
      intervalId: null
    }
  },
  computed: {
    visibleItems() {
      const bets = this.showOffGameBets || []
      if (bets.length < 10) return bets
      const startIndex = this.currentIndex
      const endIndex = startIndex + this.itemsPerPage
      return bets.slice(startIndex, endIndex)
    }
  },
  async created() {
    await getShowOffGameBets().then((response) => {
      this.showOffGameBets = response.data.data
      this.$store.commit('SET_SHOW_OFF_GAME_BETS', this.showOffGameBets)
    })
  },
  mounted() {
    this.startCarousel()
  },
  beforeDestroy() {
    this.stopCarousel()
  },
  methods: {
    shouldApplyClass(index) {
      return index % 2 !== 0
    },
    startCarousel() {
      this.intervalId = setInterval(() => {
        const showOffGameBets = this.showOffGameBets

        if (showOffGameBets && this.itemsPerPage > 0) {
          this.currentIndex = this.currentIndex + 1
        }
        if (showOffGameBets && this.currentIndex - 1 === showOffGameBets.length - this.itemsPerPage) {
          this.currentIndex = 0
        }
      }, 3000)
    },
    stopCarousel() {
      clearInterval(this.intervalId)
    },
    getImageSource(type) {
      switch (type) {
        case 1:
          return this.getThemeImagePath('slots.png')
        case 2:
          return this.getThemeImagePath('live.png')
        case 10:
          return this.getThemeImagePath('skill.png')
        case 13:
          return this.getThemeImagePath('pachislot.png')
        default:
          return this.getThemeImagePath('slots.png')
      }
    },
    getThemeImagePath,
    handleLaunchGame(item) {
      const gameData = {}
      gameData.id = item.game_id
      gameData.game_open_type = item.game_provider.game_open_type

      gameStart('game', gameData)
    }
  }
}

</script>
